// Auth helpers for Emergent Google OAuth
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

import { getApiBase } from './apiBase';

export const startLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + '/';
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const exchangeSessionId = async (sessionId) => {
  const res = await fetch(`${getApiBase()}/auth/session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-ID': sessionId,
    },
    credentials: 'include',
  });
  if (!res.ok) {
    throw new Error(`Auth exchange failed: ${res.status}`);
  }
  return res.json();
};

export const fetchMe = async (timeoutMs = 8000) => {
  // Defensive timeout — if the network hangs the app must never get stuck on "Loading…"
  const ac = new AbortController();
  const timer = setTimeout(() => ac.abort(), timeoutMs);
  try {
    const res = await fetch(`${getApiBase()}/auth/me`, {
      method: 'GET',
      credentials: 'include',
      signal: ac.signal,
    });
    if (!res.ok) return null;
    return await res.json();
  } catch (e) {
    // Network failure, timeout, or CORS rejection → treat as unauthenticated
    return null;
  } finally {
    clearTimeout(timer);
  }
};

export const logout = async () => {
  await fetch(`${getApiBase()}/auth/logout`, {
    method: 'POST',
    credentials: 'include',
  });
};
